import {
  TAILLE_ICON_HAUTEUR,
  TAILLE_ICON_LARGEUR,
  TAILLE_ICON_PLUS_GRAND,
} from '@/services/gestionIcon/iconColorGetter'

export const ZOOM_DEFAULT = 6;
export const CENTER_DEFAULT = { lat: 47.122743573054784,  lng: 2.364756481249981 };
export const CLE_GOOGLE_API = 'AIzaSyCv-YvtnpWFMggWL7BoyahVNxgVPZA9qsE';
export const RAYON_MAX = 100;
export const RAYON_MIN = 1;
export const RAYON_DEFAULT = 10;
export const RAYON_STEP = 1;
export const COULEUR_PUCE_DEFAULT = '#f44e3b';
export const MARKER_POINT_NOIR = {
  url: require('@/assets/images/icon/icon_position.png'),
  size: { width: TAILLE_ICON_LARGEUR * TAILLE_ICON_PLUS_GRAND/ TAILLE_ICON_HAUTEUR, height: TAILLE_ICON_PLUS_GRAND, f: 'px', b: 'px' },
  scaledSize: { width: TAILLE_ICON_LARGEUR * TAILLE_ICON_PLUS_GRAND/ TAILLE_ICON_HAUTEUR, height: TAILLE_ICON_PLUS_GRAND, f: 'px', b: 'px' },
};

export const MAP_TYPE_CONTROL_OPTIONS =  {
  mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
};
export const MAP_TYPE_NAME = 'Cacher POI';

export const STYLE_MAPS_POI_HIDDEN = [
  {
    'featureType': 'administrative',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'poi',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'transit',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  }
];